'use client'

import { cn, formatDateTime } from '@/lib/utils'
import React from 'react'

interface ClockProps extends React.ComponentPropsWithoutRef<'div'> {}

export const Clock = ({ className }: ClockProps) => {
  const [time, setTime] = React.useState(new Date())
  const clockWorkerRef = React.useRef<Worker | null>(null)

  React.useEffect(() => {
    let isMounted = true

    const worker = new Worker(
      new URL('@/lib/workers/clock.worker', import.meta.url),
    )
    clockWorkerRef.current = worker

    worker.onerror = (error) => {
      console.error('Error:', error)
    }

    worker.onmessage = (event: MessageEvent) => {
      if (isMounted) {
        setTime(new Date(event.data))
      }
    }

    worker.postMessage('')

    return () => {
      isMounted = false
      worker.terminate()
      clockWorkerRef.current = null
    }
  }, [])

  return (
    <div
      suppressHydrationWarning
      className={cn('hidden md:inline-flex', className)}
    >
      {formatDateTime(time)}
    </div>
  )
}

Clock.displayName = 'Clock'
